import React, { useState, useEffect } from "react";
import { useAppContext } from "../context/ContextProvider";
import AgregarTarea from "./AgregarTarea";
import ListadoTareas from "./ListadoTareas";
import Logueo from "./Logueo";
import firebaseApp from "../index";
import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore";

const Tareas = () => {
    const firestore = getFirestore(firebaseApp);
    const { usuarioGlobal, correoUsuario } = useAppContext();
    const [arrayTareas, setArrayTareas] = useState(null);

    useEffect(() => {
        async function buscarDocumentOrCrearDocumento(idDocumento) {
            //crear referencia al documento
            const docuRef = doc(firestore, `usuarios/${idDocumento}`);
            // buscar documento
            const consulta = await getDoc(docuRef);
            // revisar si existe
            if (consulta.exists()) {
                // si sí existe
                const infoDocu = consulta.data();
                return infoDocu.tareas;
            } else {
                // si no existe
                await setDoc(docuRef, { tareas: [] });
                const consulta = await getDoc(docuRef);
                const infoDocu = consulta.data();
                return infoDocu.tareas;
            }
        }
        async function fetchTareas() {
            const tareasFetchadas = await buscarDocumentOrCrearDocumento(
                correoUsuario
            );
            setArrayTareas(tareasFetchadas);
        }
        fetchTareas();
    }, []);
    return usuarioGlobal ? (
        <section class="body-font text-white">
            <div class="container px-5 py-24 mx-auto">
                <div class="flex flex-col text-center w-full mb-20">
                    <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-white">
                        Tareas Pendientes
                    </h1>
                    <AgregarTarea
                        arrayTareas={arrayTareas}
                        setArrayTareas={setArrayTareas}
                    />
                    {arrayTareas ? (
                        <ListadoTareas
                            arrayTareas={arrayTareas}
                            setArrayTareas={setArrayTareas}
                        />
                    ) : null}
                </div>
            </div>
        </section>
    ) : (
        <Logueo />
    );
};

export default Tareas;
